import { lazyWithPreload } from '../../navigation';

export * from './IntegrationsModal';
export * from './integrations.utils';
export * from './IntegrationsLegacyRedirect';

export const IntegrationScreen = lazyWithPreload(() =>
    import('./IntegrationScreen').then((m) => ({ default: m.IntegrationScreen }))
);
export const IntegrationsScreen = lazyWithPreload(() =>
    import('./IntegrationsScreen').then((m) => ({ default: m.IntegrationsScreen }))
);
